// extracted by mini-css-extract-plugin
export default {"Banner--warning":"Modal_Banner--warning__DFrTB","Banner--alert":"Modal_Banner--alert__mwnT-","modal":"Modal_modal__dCekn"};